import e, { useEffect as b } from "react";
import { useAtom as y, useSetAtom as I } from "jotai";
import { CollapsibleContainer as x } from "./index94.mjs";
import p from "./index241.mjs";
import { allocateGuestsAtom as M } from "./index34.mjs";
import { totalChildrenAtom as v } from "./index26.mjs";
import { Button as S } from "./index82.mjs";
import { track as k } from "./index9.mjs";
import { TRACK_EVENT_TYPE as G, TRACK_EVENT as N } from "./index10.mjs";
import { GuestsStepper as L } from "./index159.mjs";
import { useHotelConfig as O } from "./index93.mjs";
import { getSubscriptionPlanRoot as P } from "./index14.mjs";
const q = ({
  cartItem: d,
  isExpanded: h,
  setIsExpanded: c
}) => {
  const {
    id: t,
    totalAdults: o,
    totalChildren: n,
    maxAdults: a,
    maxOccupancy: r,
    maxChildren: l
  } = d, [f] = y(v), i = I(M), s = l === null ? Math.max(r - o, 0) : l, C = `${I18n.t(
    "booking_engine.information.max_guests"
  )}: ${I18n.t(
    `booking_engine.information.people.${r === 1 ? "one" : "other"}`,
    { count: r.toString() }
  )}`, { hotelId: _, propertySize: A, propertyType: g, subscriptionPlan: E } = O(), u = o + n < 1, T = () => {
    k(N.CLICK, G.GUEST_ALLOCATION_COMPLETED, {
      hotel_id: _,
      property_type: g,
      property_size: A,
      subscription_plan: P(E)
    }), c();
  };
  return b(() => {
    i({
      cartItemId: t,
      personType: "totalAdults",
      amount: Math.min(o, a)
    }), i({
      cartItemId: t,
      personType: "totalChildren",
      amount: Math.min(n, s)
    });
  }, [
    i,
    t,
    a,
    l,
    o,
    n,
    s
  ]), /* @__PURE__ */ e.createElement(
    x,
    {
      title: I18n.t("booking_engine.information.allocate_room"),
      expand: h,
      setExpand: c,
      isDisabled: u
    },
    /* @__PURE__ */ e.createElement("div", { className: p.container }, /* @__PURE__ */ e.createElement("div", { "data-testid": "room-occupancy-limits" }, C), /* @__PURE__ */ e.createElement("div", { className: p["steps-container"] }, /* @__PURE__ */ e.createElement(
      L,
      {
        showChildren: !!(t && f > 0),
        setAmountAdults: (m) => {
          i({ cartItemId: t, personType: "totalAdults", amount: m });
        },
        setAmountChildren: (m) => {
          i({
            cartItemId: t,
            personType: "totalChildren",
            amount: m
          });
        },
        limitAdults: Math.min(a, r - n),
        limitChildren: s,
        amountAdults: Math.min(o, a),
        amountChildren: Math.min(n, s)
      }
    )), /* @__PURE__ */ e.createElement(
      S,
      {
        disabled: u,
        label: I18n.t("booking_engine.information.save_guests"),
        dataTestId: "save-guests-button",
        classes: p.save_guests,
        onClick: T
      }
    ))
  );
};
export {
  q as AllocateGuests
};
